import { OktaAuth } from '@okta/okta-auth-js'

export const oktaConfig = {
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
  issuer: import.meta.env.VITE_OKTA_ISSUER,
  redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  baseUrl: import.meta.env.VITE_OKTA_URL,
  useClassicEngine: true,
  authParams: {
    issuer: import.meta.env.VITE_OKTA_ISSUER,
    scopes: ["openid", "profile", "email"],
  },
}

// Export a singleton OktaAuth instance for use across the app
export const oktaAuth = new OktaAuth(oktaConfig)
